import React from 'react'
import { Input, SelectInput } from "../common/form";
import { ReactComponent as IconTrash } from "assets/images/icons/project-icons/thrash.svg";
import { REGEX_VALUES } from 'utils/regexValues';

export const CustomDeductions = (props) => {
    const { form, setForm } = props;
        
    const handleUpdateCustomDeduction = (id, updatedData) => {
        setForm(prevState => {
            const newCustomDeductions = prevState.deductions.custom_deductions.map(item => {
                if (item.id === id) {
                    return {
                        ...item,
                        ...updatedData,
                    };
                }
                return item;
            });
            return {
                ...prevState,
                deductions: {
                    ...prevState.deductions,
                    custom_deductions:  [...newCustomDeductions],
                },
            };
        });
    };
    
    const handleDeleteCustomDeduction = (id) => {
        setForm(prevState => {
            const newCustomDeductions = prevState.deductions.custom_deductions.filter(customDeduction => customDeduction.id !== id);
            
            return {
                ...prevState,
                deductions: {
                    ...prevState.deductions,
                    custom_deductions: newCustomDeductions,
                },
            }
        });
    }
    
    return (
        <div>
            <div className='mb-4 pt-4'>
                <h4 className='text-[#1A202C] font-bold text-[16px]'>Custom Deduction</h4>
            </div>
            <div>
                {
                    form.deductions.custom_deductions.map((customDeduction) => {
                        
                        return (
                            <div key={customDeduction.id}>
                                <div key={customDeduction.id} className='relative'>
                                    <Input 
                                        type="text"
                                        label="Name"
                                        placeholder="Input Here"
                                        value={customDeduction.name}
                                        onChange={(evt) => {
                                            const { value } = evt.target;
                                            if (!REGEX_VALUES.LETTERS_WITH_NUMBERS_AND_HYPHEN_ONLY.test(value) || value.length > 50) {
                                                return;
                                            }
                                            handleUpdateCustomDeduction(customDeduction.id, {
                                                ...customDeduction,
                                                name: value,
                                            })
                                        }}
                                        required
                                    />
                                    <IconTrash 
                                        className='absolute right-0 top-0 cursor-pointer' 
                                        onClick={() => handleDeleteCustomDeduction(customDeduction.id)} 
                                    />
                                </div>
                                <Input 
                                    type="text"
                                    label="Description"
                                    placeholder="Input Here"
                                    value={customDeduction.description}
                                    onChange={(evt) => {
                                        const { value } = evt.target;
                                        
                                        handleUpdateCustomDeduction(customDeduction.id, {
                                            ...customDeduction,
                                            description: value,
                                        })
                                    }}
                                />
                                <SelectInput 
                                    label="Deduction Type" 
                                    required
                                    value={customDeduction.type}
                                    onChange={(evt) => {
                                        const { value } = evt.target;
                                        
                                        handleUpdateCustomDeduction(customDeduction.id, {
                                            ...customDeduction,
                                            type: value,
                                        })
                                    }}
                                >
                                    <option value="">Select</option>
                                    <option value="PERCENTAGE">Percentage</option>
                                    <option value="FIXED_AMOUNT">Fixed Amount</option>
                                </SelectInput>
                                <Input 
                                    type="number"
                                    label="Deduction Value"
                                    className="input-number"
                                    placeholder="Input Here"
                                    required
                                    value={customDeduction.value}
                                    onChange={(evt) => {
                                        const { value } = evt.target;
                                        
                                        handleUpdateCustomDeduction(customDeduction.id, {
                                            ...customDeduction,
                                            value,
                                        })
                                    }}
                                />
                                <SelectInput 
                                    label="Deduction Source" 
                                    required
                                    value={customDeduction.source} 
                                    onChange={(evt) => {
                                        const { value } = evt.target;
                                        
                                        handleUpdateCustomDeduction(customDeduction.id, {
                                            ...customDeduction,
                                            source: value,
                                        })
                                    }}
                                >
                                    <option value="">Select</option>
                                    <option value="BASIC">Basic</option>
                                    <option value="HOUSING">Housing</option>
                                    <option value="TRANSPORT">Transport</option>
                                    <option value="BASIC_AND_HOUSING">Basic and Housing</option>
                                    <option value="BASIC_AND_TRANSPORT">Basic and Transport</option>
                                    <option value="HOUSING_AND_TRANSPORT">Housing and Transport</option>
                                    <option value="BASIC_HOUSING_AND_TRANSPORT">Basic, Housing and Transport</option>
                                    <option value="GROSS_SALARY">Gross Salary</option>
                                </SelectInput>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}
